export const EVENT_SELECT = 'select';

export const ALL_WASHING_VIALS_VALUE = 0;

export const WASHING_VIALS = [1, 2, 3, 4] as const;

export const props = {
  isDisabled: {
    type: Boolean,
  },
};
